export { default } from './es/icons/WordTwoTone';